import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { QuoteRate } from '@/views/screens/Quote';
import type { AxiosResponse } from 'axios';

const getQuoteRateResultsApi = (quoteKey: string) => {
  return axiosInstance.request({
    url: `${API.RATE}/quote-rate-results/${quoteKey}`,
    method: 'get',
  });
};

export type QuoteRateResultsResponse = {
  rateResults: QuoteRate[];
};

export const fetchQuoteRateResults = async (quoteKey: string): Promise<QuoteRateResultsResponse> => {
  const response: AxiosResponse<QuoteRateResultsResponse> = await getQuoteRateResultsApi(quoteKey);
  return response.data;
};
